﻿import api from '../api';

export interface AbaInformacaoComplementar {
  contratoId?: string;
  teste: Array<string>;
  informacaoComplementar_DiretoriaId?: string;
  informacaoComplementar_AreaId?: string;
  informacaoComplementar_GestorId?: string;
  informacaoComplementar_FiscalId?: string;
  informacaoComplementar_TecnicoMedicaoId?: string;
  informacaoComplementar_FiscalAlternativoId?: string;
  informacaoComplementar_AdministradorContrato?: string;
  informacaoComplementar_AdministradorContratoAlternativo?: string;

  informacaoComplementar_AdministradorContratoId?: string;
  informacaoComplementar_AdministradorContratoAlternativoId?: string;
  informacaoComplementar_ResponsavelRateioId?: string;

  informacaoComplementar_DataValidaInicio?: Date;
  informacaoComplementar_DataValidaFinal?: Date;
  informacaoComplementar_DataBase?: Date;
  informacaoComplementar_FrequenciaReajuste?: string;
  informacaoComplementar_IndiceReajuste?: string;
  informacaoComplementar_TipoMedicaoId?: string;
  informacaoComplementar_TipoMedicaoCodigo?: number;
  informacaoComplementar_FrequenciaMedicaoId?: string;
  informacaoComplementar_FrequenciaMedicaoQuantitativaId: string;
  informacaoComplementar_PossuiSla?: boolean;
  informacaoComplementar_FrequenciaSla?: string;
  informacaoComplementar_DataPrimeiraMedicao?: Date;
  informacaoComplementar_PossuiDocumentacaoAcessorial?: boolean;
  informacaoComplementar_PossuiSeguroEGarantia?: boolean;

  informacaoComplementar_Responsavel: string;
  informacaoComplementar_EmailResponsavel?: string;
  informacaoComplementar_EmailResponsavelFinanceiro?: string;

  informacaoComplementar_FornecedorGestorNome?: string;
  informacaoComplementar_FornecedorGestorEmail?: string;
  informacaoComplementar_FornecedorGestorUltimoAcesso?: string;

  informacaoComplementar_NomeFiscal?: string;
  informacaoComplementar_FornecedorEmailFiscal?: string;
  informacaoComplementar_UltimoAcessoFiscal?: string;
  informacaoComplementar_DepartamentoId?: string;

  informacaoComplementar_NomeFinanceiro?: string;
  informacaoComplementar_FornecedorEmailFinanceiro?: string;
  informacaoComplementar_UltimoAcessoFinanceiro?: string;

  informacaoComplementar_PossuiArea: boolean;
  informacaoComplementar_PossuiDepartamento: boolean;
  informacaoComplementar_ContratoLegivelParaProcessoNda: boolean;

  informacaoComplementar_UtilizaProcessoRateio: boolean;
  informacaoComplementar_AprovacaoPagamentoAutomatica: boolean;

  informacaoComplementar_CondicaoPagamento: string;
  informacaoComplementar_DataMensalLimiteInserirMedicao: number;
  informacaoComplementar_DataMensalLimiteValidarMedicao: number;
  informacaoComplementar_DataMensalLimiteInserirMedicaoAplicavel: boolean;
  informacaoComplementar_DataMensalLimiteValidarMedicaoAplicavel: boolean;

  informacaoComplementar_ResponsavelTac?: string;
  informacaoComplementar_EmailResponsavelTac?: string;
  informacaoComplementar_UltimoAcessoResponsavelTac?: string;
  hasResponsavelTac: boolean;
  caracteristicaServico_MaoDeObraAlocadaPTR: boolean;

  
  informacaoComplementar_DataMensalLimiteReapresentarMedicao: number;
  informacaoComplementar_DataMensalLimiteReavaliarMedicao: number;
  informacaoComplementar_DataMensalLimiteAutorizarFaturamento: number;
}

export const getInformacaoComplementarById = (contratoId: any) =>
  api.get<AbaInformacaoComplementar>(`contratos/infocomplementar/${contratoId}`);

export const updateDadosReajusteContrato = (abaInformacaoComplementar: AbaInformacaoComplementar) =>
  api.put(`contratos/dadosreajuste/${abaInformacaoComplementar.contratoId}`, abaInformacaoComplementar);

export const updateResponsaveisMrnContrato = (abaInformacaoComplementar: AbaInformacaoComplementar) =>
  api.put(`contratos/responsaveismrn/${abaInformacaoComplementar.contratoId}`, abaInformacaoComplementar);

export const updateResponsaveisFornecedorContrato = (abaInformacaoComplementar: AbaInformacaoComplementar) =>
  api.put(`contratos/responsaveisfornecedor/${abaInformacaoComplementar.contratoId}`, abaInformacaoComplementar);

export const updateFrequenciaMedicaoContrato = (abaInformacaoComplementar: AbaInformacaoComplementar) =>
  api.put(
    `frequenciasMedicao/${abaInformacaoComplementar.informacaoComplementar_FrequenciaMedicaoId}`,
    abaInformacaoComplementar,
  );
export const updateOutrasInformacoesContrato = (abaInformacaoComplementar: AbaInformacaoComplementar) =>
  api.put(`contratos/outrasinformacoes/${abaInformacaoComplementar.contratoId}`, abaInformacaoComplementar);

export const updateCronologiaMedicaoContrato = (abaInformacaoComplementar: AbaInformacaoComplementar) =>
  api.put<any>(`contratos/cronologiaMedicao/${abaInformacaoComplementar.contratoId}`, abaInformacaoComplementar);
